import { render, staticRenderFns } from "./JournalRfs.vue?vue&type=template&id=337674d6"
import script from "./JournalRfs.vue?vue&type=script&lang=js"
export * from "./JournalRfs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports